
export { useDevice } from "/codebuild/output/src2558486121/src/dgbet/src/contexts/device/index.tsx"